<template>
  <div>

    <div class="card" qid="risk-criteria-section">

      <div class="card-header border-bottom-0">
        <div class="row">
          <div class="col-md-6">
            <h4 qid="risk-criteria-section-title" class="mb-3">
              {{ $t('activities.risk_scenario.inherent_risk.risk_criteria_label') }}
            </h4>
          </div>
          <div class="col-md-6">
            <b-button
                @click="showFormFunction"
                v-if="isGranted([permissions.RISK_CATEGORY_DELETE, permissions.RISK_CATEGORY_DELETE_OWN], riskCategory.created_by) && (!getClient.parent || (getClient.parent && riskCategory.partition))"
                variant="success"
                class="float-right"
                qid="edit-risk-criteria-button"
            >
              <font-awesome-icon icon="pen"/> {{ $t('maintenance.risk_categories.update.risk_criteria_button') }}
            </b-button>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark font-weight-bold">
            <h6 class="mb-0">{{ $t('maintenance.risk_categories.risk.confidentiality_impact_definitions_label') }}</h6>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="text-center">
              <h6>Business risk</h6>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="text-center">
              <h6>Privacy risk</h6>
            </div>
          </div>
        </div>
      </div>

      <!-- Impact definitions -->


      <!-- Confidentiality impact -->

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.very_low') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_very_low_definition"
                v-model="riskForm.business_risk_confidentiality_impact_very_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_confidentiality_impact_very_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_confidentiality_impact_very_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_very_low_definition"
                v-model="riskForm.privacy_risk_confidentiality_impact_very_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_confidentiality_impact_very_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_confidentiality_impact_very_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.low') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_low_definition"
                v-model="riskForm.business_risk_confidentiality_impact_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_confidentiality_impact_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_confidentiality_impact_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_low_definition"
                v-model="riskForm.privacy_risk_confidentiality_impact_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_confidentiality_impact_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_confidentiality_impact_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.high') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_high_definition"
                v-model="riskForm.business_risk_confidentiality_impact_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_confidentiality_impact_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_confidentiality_impact_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_high_definition"
                v-model="riskForm.privacy_risk_confidentiality_impact_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_confidentiality_impact_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_confidentiality_impact_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.very_high') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_very_high_definition"
                v-model="riskForm.business_risk_confidentiality_impact_very_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_confidentiality_impact_very_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_confidentiality_impact_very_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_very_high_definition"
                v-model="riskForm.privacy_risk_confidentiality_impact_very_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_confidentiality_impact_very_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_confidentiality_impact_very_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Integrity impact -->

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu pt-3 pb-3">
          <div class="card-body text-dark p-3">
            <h6 class="mb-0">{{ $t('maintenance.risk_categories.risk.integrity_impact_definitions_label') }}</h6>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black"></div>
        <div class="col-sm-5"></div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.very_low') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_very_low_definition"
                v-model="riskForm.business_risk_integrity_impact_very_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_integrity_impact_very_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_integrity_impact_very_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_very_low_definition"
                v-model="riskForm.privacy_risk_integrity_impact_very_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_integrity_impact_very_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_integrity_impact_very_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.low') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_low_definition"
                v-model="riskForm.business_risk_integrity_impact_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_integrity_impact_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_integrity_impact_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_low_definition"
                v-model="riskForm.privacy_risk_integrity_impact_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_integrity_impact_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_integrity_impact_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.high') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_high_definition"
                v-model="riskForm.business_risk_integrity_impact_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_integrity_impact_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_integrity_impact_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_high_definition"
                v-model="riskForm.privacy_risk_integrity_impact_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_integrity_impact_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_integrity_impact_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.very_high') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_very_high_definition"
                v-model="riskForm.business_risk_integrity_impact_very_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_integrity_impact_very_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_integrity_impact_very_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_very_high_definition"
                v-model="riskForm.privacy_risk_integrity_impact_very_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_integrity_impact_very_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_integrity_impact_very_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Availability impact -->

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu pt-3 pb-3">
          <div class="card-body text-dark p-3">
            <h6 class="mb-0">{{ $t('maintenance.risk_categories.risk.availability_impact_definitions_label') }}</h6>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black"></div>
        <div class="col-sm-5"></div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.very_low') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_very_low_definition"
                v-model="riskForm.business_risk_availability_impact_very_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_availability_impact_very_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_availability_impact_very_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_very_low_definition"
                v-model="riskForm.privacy_risk_availability_impact_very_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_availability_impact_very_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_availability_impact_very_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.low') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_low_definition"
                v-model="riskForm.business_risk_availability_impact_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_availability_impact_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_availability_impact_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_low_definition"
                v-model="riskForm.privacy_risk_availability_impact_low_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.low')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_availability_impact_low_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_availability_impact_low_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.high') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_high_definition"
                v-model="riskForm.business_risk_availability_impact_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_availability_impact_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_availability_impact_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_high_definition"
                v-model="riskForm.privacy_risk_availability_impact_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_availability_impact_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_availability_impact_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('impact.very_high') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_impact_very_high_definition"
                v-model="riskForm.business_risk_availability_impact_very_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_availability_impact_very_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_availability_impact_very_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_impact_very_high_definition"
                v-model="riskForm.privacy_risk_availability_impact_very_high_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('impact.very_high')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_availability_impact_very_high_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_availability_impact_very_high_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Probability definitions -->
      <div class="row no-gutters">
        <div class="col-sm-2 card-menu pt-3 pb-3">
          <div class="card-body text-dark p-3">
            <h6 class="mb-0">{{ $t('maintenance.risk_categories.risk.probability_definitions_label') }}</h6>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black"></div>
        <div class="col-sm-5"></div>
      </div>


      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('probability.very_unlikely') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_probability_very_unlikely_definition"
                v-model="riskForm.business_risk_probability_very_unlikely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.very_unlikely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_probability_very_unlikely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_probability_very_unlikely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_probability_very_unlikely_definition"
                v-model="riskForm.privacy_risk_probability_very_unlikely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.very_unlikely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_probability_very_unlikely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_probability_very_unlikely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('probability.unlikely') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_probability_unlikely_definition"
                v-model="riskForm.business_risk_probability_unlikely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.unlikely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_probability_unlikely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_probability_unlikely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_probability_unlikely_definition"
                v-model="riskForm.privacy_risk_probability_unlikely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.unlikely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_probability_unlikely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_probability_unlikely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('probability.likely') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_probability_likely_definition"
                v-model="riskForm.business_risk_probability_likely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.likely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_probability_likely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_probability_likely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_probability_likely_definition"
                v-model="riskForm.privacy_risk_probability_likely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.likely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_probability_likely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_probability_likely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <span>{{ $t('probability.very_likely') }}</span>
          </div>
        </div>
        <div class="col-sm-5" style="border-right:1px solid black">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_business_form_probability_very_likely_definition"
                v-model="riskForm.business_risk_probability_very_likely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.very_likely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.business_risk_probability_very_likely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.business_risk_probability_very_likely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="card-body">
            <div class="mw-500" v-if="showRiskForm">
              <b-form-textarea
                qid="risk_criteria_privacy_form_probability_very_likely_definition"
                v-model="riskForm.privacy_risk_probability_very_likely_definition"
                rows="6"
                max-rows="4"
                :placeholder="$t('probability.very_likely')"
              ></b-form-textarea>
            </div>
            <div v-if="!showRiskForm">
              <div v-if="riskCategory.privacy_risk_probability_very_likely_definition">
                <p class="text-formatted"
                   qid="inherent-risk-description"
                >
                  {{riskCategory.privacy_risk_probability_very_likely_definition}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row no-gutters" v-if="showRiskForm">
        <div class="col-sm-2 card-menu">
        </div>
        <div class="col-sm-10">
          <div class="card-body">
            <div class="text-right">
              <b-button class=""
                        variant="secondary"
                        @click="cancelFormFunction"
                        qid="risk-criteria-form-cancel-button"
              >
                {{ $t('maintenance.risk_categories.create.cancel') }}
              </b-button>
              <b-button class="ml-3"
                        variant="success"
                        @click="riskFormSubmit"
                        qid="risk-criteria-form-submit-button"
              >
                {{ $t('maintenance.risk_categories.create.submit') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'CiaDefinitions',
    data: function() {
      return {
        error: '',
        buttonDisabled: false,

        riskForm: {
          business_risk_confidentiality_impact_very_low_definition: '',
          business_risk_confidentiality_impact_low_definition: '',
          business_risk_confidentiality_impact_high_definition: '',
          business_risk_confidentiality_impact_very_high_definition: '',

          privacy_risk_confidentiality_impact_very_low_definition: '',
          privacy_risk_confidentiality_impact_low_definition: '',
          privacy_risk_confidentiality_impact_high_definition: '',
          privacy_risk_confidentiality_impact_very_high_definition: '',


          business_risk_integrity_impact_very_low_definition: '',
          business_risk_integrity_impact_low_definition: '',
          business_risk_integrity_impact_high_definition: '',
          business_risk_integrity_impact_very_high_definition: '',

          privacy_risk_integrity_impact_very_low_definition: '',
          privacy_risk_integrity_impact_low_definition: '',
          privacy_risk_integrity_impact_high_definition: '',
          privacy_risk_integrity_impact_very_high_definition: '',


          business_risk_availability_impact_very_low_definition: '',
          business_risk_availability_impact_low_definition: '',
          business_risk_availability_impact_high_definition: '',
          business_risk_availability_impact_very_high_definition: '',

          privacy_risk_availability_impact_very_low_definition: '',
          privacy_risk_availability_impact_low_definition: '',
          privacy_risk_availability_impact_high_definition: '',
          privacy_risk_availability_impact_very_high_definition: '',


          business_risk_probability_very_unlikely_definition: '',
          business_risk_probability_unlikely_definition: '',
          business_risk_probability_likely_definition: '',
          business_risk_probability_very_likely_definition: '',

          privacy_risk_probability_very_unlikely_definition: '',
          privacy_risk_probability_unlikely_definition: '',
          privacy_risk_probability_likely_definition: '',
          privacy_risk_probability_very_likely_definition: '',
        },

        showRiskForm: false,
        riskCategory: this.category
      }
    },
    props: {
      category: {
        type: Object
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadContent();
      },
      category: function (newValue) {
        this.riskCategory = newValue
      }
    },
    methods: {
      showFormFunction() {
        let self = this;

        this.riskForm.business_risk_confidentiality_impact_very_low_definition = this.riskCategory.business_risk_confidentiality_impact_very_low_definition;
        this.riskForm.business_risk_confidentiality_impact_low_definition = this.riskCategory.business_risk_confidentiality_impact_low_definition;
        this.riskForm.business_risk_confidentiality_impact_high_definition = this.riskCategory.business_risk_confidentiality_impact_high_definition;
        this.riskForm.business_risk_confidentiality_impact_very_high_definition = this.riskCategory.business_risk_confidentiality_impact_very_high_definition;

        this.riskForm.business_risk_integrity_impact_very_low_definition = this.riskCategory.business_risk_integrity_impact_very_low_definition;
        this.riskForm.business_risk_integrity_impact_low_definition = this.riskCategory.business_risk_integrity_impact_low_definition;
        this.riskForm.business_risk_integrity_impact_high_definition = this.riskCategory.business_risk_integrity_impact_high_definition;
        this.riskForm.business_risk_integrity_impact_very_high_definition = this.riskCategory.business_risk_integrity_impact_very_high_definition;

        this.riskForm.business_risk_availability_impact_very_low_definition = this.riskCategory.business_risk_availability_impact_very_low_definition;
        this.riskForm.business_risk_availability_impact_low_definition = this.riskCategory.business_risk_availability_impact_low_definition;
        this.riskForm.business_risk_availability_impact_high_definition = this.riskCategory.business_risk_availability_impact_high_definition;
        this.riskForm.business_risk_availability_impact_very_high_definition = this.riskCategory.business_risk_availability_impact_very_high_definition;


        this.riskForm.privacy_risk_confidentiality_impact_very_low_definition = this.riskCategory.privacy_risk_confidentiality_impact_very_low_definition;
        this.riskForm.privacy_risk_confidentiality_impact_low_definition = this.riskCategory.privacy_risk_confidentiality_impact_low_definition;
        this.riskForm.privacy_risk_confidentiality_impact_high_definition = this.riskCategory.privacy_risk_confidentiality_impact_high_definition;
        this.riskForm.privacy_risk_confidentiality_impact_very_high_definition = this.riskCategory.privacy_risk_confidentiality_impact_very_high_definition;

        this.riskForm.privacy_risk_integrity_impact_very_low_definition = this.riskCategory.privacy_risk_integrity_impact_very_low_definition;
        this.riskForm.privacy_risk_integrity_impact_low_definition = this.riskCategory.privacy_risk_integrity_impact_low_definition;
        this.riskForm.privacy_risk_integrity_impact_high_definition = this.riskCategory.privacy_risk_integrity_impact_high_definition;
        this.riskForm.privacy_risk_integrity_impact_very_high_definition = this.riskCategory.privacy_risk_integrity_impact_very_high_definition;

        this.riskForm.privacy_risk_availability_impact_very_low_definition = this.riskCategory.privacy_risk_availability_impact_very_low_definition;
        this.riskForm.privacy_risk_availability_impact_low_definition = this.riskCategory.privacy_risk_availability_impact_low_definition;
        this.riskForm.privacy_risk_availability_impact_high_definition = this.riskCategory.privacy_risk_availability_impact_high_definition;
        this.riskForm.privacy_risk_availability_impact_very_high_definition = this.riskCategory.privacy_risk_availability_impact_very_high_definition;


        this.riskForm.business_risk_probability_very_unlikely_definition = this.riskCategory.business_risk_probability_very_unlikely_definition;
        this.riskForm.business_risk_probability_unlikely_definition = this.riskCategory.business_risk_probability_unlikely_definition;
        this.riskForm.business_risk_probability_likely_definition = this.riskCategory.business_risk_probability_likely_definition;
        this.riskForm.business_risk_probability_very_likely_definition = this.riskCategory.business_risk_probability_very_likely_definition;

        this.riskForm.privacy_risk_probability_very_unlikely_definition = this.riskCategory.privacy_risk_probability_very_unlikely_definition;
        this.riskForm.privacy_risk_probability_unlikely_definition = this.riskCategory.privacy_risk_probability_unlikely_definition;
        this.riskForm.privacy_risk_probability_likely_definition = this.riskCategory.privacy_risk_probability_likely_definition;
        this.riskForm.privacy_risk_probability_very_likely_definition = this.riskCategory.privacy_risk_probability_very_likely_definition;

        this.showRiskForm = true;
      },
      cancelFormFunction() {
        this.showRiskForm = false;
      },
      riskFormSubmit() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        piincHttp.put('risk-categories/' + this.$route.params.slug, this.riskForm).then(function(response) {
          self.riskCategory = response.data
          self.buttonDisabled = false;
          self.cancelFormFunction();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
    },
    components: {

    },
    created () {
      this.riskCategory = this.category
    }
  }
</script>
